import {
  CustomerFeatureSettingResponse,
  CustomerFeatureSettings,
} from 'src/routes/Customers/modules/types';

export const mergeCustomerFeatureSettings = (
  customerId: string,
  rawData: CustomerFeatureSettingResponse[],
) =>
  rawData?.reduce(
    (acc: CustomerFeatureSettings, item) => {
      acc[item.name] = item.featureAvailable;
      return acc;
    },
    { customerId },
  );
